export default {
  title: {
    nl: 'Network error'
  },

  text: {
    nl: 'Please check your internet connection.'
  },

  button: {
    nl: 'Done'
  }
};
